import React from "react";

import { normalizeContent } from "./composer/content";
import { FileChip, JsonBlock, ThreadImage, UnsupportedBlock, isImageBlock } from "./fileBlocks";

/**
 * ContentBody — a content array rendered in order: prose, and the files where their author put them.
 *
 * The one renderer for content outside a thread row, so a brief and a meta-thread record cannot come to
 * disagree about what an inline image is. WHICH types may render as an image is `isImageBlock`'s
 * decision and nothing here makes a second one — see AGENTS.md, "Thread Attachments".
 *
 * Props:
 *   content     — string | Block[] | null; a string is one text block
 *   fileContext — { api, revisionId, sessionId }; without it a file block cannot fetch its bytes
 *   className   — carried by each text run, so a caller keeps its own prose styling
 *   renderText  — (text, index) => node; optional, for a caller that renders markdown
 */
export default function ContentBody({ content, fileContext, className, renderText }) {
  const blocks = normalizeContent(content);
  if ( 0 === blocks.length ) return null;
  return (
    <>
      {blocks.map((block, index) => {
        if ( "text" === block.type ) {
          return renderText
            ? <React.Fragment key={index}>{renderText(block.text, index)}</React.Fragment>
            : <div key={index} className={className}>{block.text}</div>;
        }
        if ( "json" === block.type ) return <JsonBlock key={index} value={block.json} />;
        if ( "file" === block.type ) {
          return isImageBlock(block)
            ? <ThreadImage key={index} fileContext={fileContext} block={block} />
            : <FileChip key={index} fileContext={fileContext} block={block} />;
        }
        return <UnsupportedBlock key={index} type={block.type} />;
      })}
    </>
  );
}
